import authHeader from "./auth-header";
import axiosInstance from "./instance";

class ActivationService {
  getEmails(deleted) {
    return axiosInstance.get("/ship_data_emails", {
      headers: authHeader(),
      params: { deleted: deleted ? 1 : 0 },
    });
  }
  changeEmailsVisibility(data) {
    return axiosInstance.put("/ship_data_emails", data, {
      headers: authHeader(),
    });
  }
  getEmailsRules() {
    return axiosInstance.get("/email_rules", {
      headers: authHeader(),
    });
  }
  updateEmailsRules(data) {
    return axiosInstance.put("/update_emails_rules", data, {
      headers: authHeader(),
    });
  }
  deleteEmailsRules(data) {
    return axiosInstance.post("/delete_emails_rules", data, {
      headers: authHeader(),
    });
  }
  computeKpi(data) {
    return axiosInstance.post("/compute_activation_time_kpi", data, {
      headers: authHeader(),
    });
  }
}

export default new ActivationService();
